






// Import vendors ----------------------------------------------------------------------------------
import { defineComponent } from '@vue/composition-api';
import { useService } from '@xstate/vue';
// Import plugins ----------------------------------------------------------------------------------
import { usePodocore } from '@/plugins/podocore';
// Import components -------------------------------------------------------------------------------
import AuthCompleteProfile from '@/components/auth/completeProfile/AuthCompleteProfile.vue';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'PageAuthCompleteProfile',
  components: { AuthCompleteProfile },
  setup() {
    const doctorService = useService(usePodocore().getModuleService('doctor'));

    return {
      doctorService
    };
  }
});
